import React from 'react';
import VeltTextCommentToolbarCommentAnnotation from './VeltTextCommentToolbarCommentAnnotation/VeltTextCommentToolbarCommentAnnotation';
import VeltTextCommentToolbarCopywriter from './VeltTextCommentToolbarCopywriter/VeltTextCommentToolbarCopywriter';
import VeltTextCommentToolbarGeneric from './VeltTextCommentToolbarGeneric/VeltTextCommentToolbarGeneric';
import VeltTextCommentToolbarSeperator from './VeltTextCommentToolbarSeperator/VeltTextCommentToolbarSeperator';
var VeltTextCommentToolbar = function (props) {
    var children = props.children;
    return (React.createElement("velt-text-comment-toolbar-wireframe", null, children));
};
VeltTextCommentToolbar.CommentAnnotation = VeltTextCommentToolbarCommentAnnotation;
VeltTextCommentToolbar.Copywriter = VeltTextCommentToolbarCopywriter;
VeltTextCommentToolbar.Generic = VeltTextCommentToolbarGeneric;
VeltTextCommentToolbar.Seperator = VeltTextCommentToolbarSeperator;
export default VeltTextCommentToolbar;
